import { connect } from 'react-redux';
import { IGetVillageListResponseSchema } from '../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { IApplicationState, TTypedThunkDispatch } from '../../types/store';
import { IRoad } from '../../types/geo';
import { Roads } from '.';
import { changeRoadDistance } from '../../store/filters/actions';
import { IRoads } from '../../store/roads';
import { changePopupRoadDistance, changeSubroads } from '../../store/roads/actions';
import { isArrayWithItems } from '../../utils';
import { groupBy } from '../../utils/groupBy';
import { commutePick } from '../../utils/commutePick';

export interface IRoadsProps {
  groupedRoads: { [key: number]: IRoad[] };
  regionId: number;
  roadData: IGetVillageListResponseSchema['roadData'];
  roads: IRoads;
}

export interface IRoadsDispatchProps {
  onChangeSubroads(ids: number[], checked: boolean): void;
  onChangePopupRoadDistance(value: number): void;
  onChangeRoadDistance(value: number): void;
}

export type TRoadsProps = IRoadsProps & IRoadsDispatchProps;

export interface IRoadModel extends IRoad {
  withoutSubroads?: boolean;
}

export function mapStateToProps(state: IApplicationState): IRoadsProps {
  const {
    geo: { selectedRegion },
    roads,
    villageList: { roadData },
  } = state;
  const currentRoads = [...roads.currentRoads].sort((a, b) => a.directionIndex - b.directionIndex);

  const groupedRoads = groupBy(currentRoads, 'directionId');
  if (isArrayWithItems(groupedRoads['null'])) {
    groupedRoads['null'].forEach((nullRoad: IRoadModel) => {
      nullRoad.withoutSubroads = true;
      groupedRoads[nullRoad.id] = [nullRoad];
    });
  }

  return {
    groupedRoads,
    regionId: selectedRegion ? selectedRegion.id : 1,
    roadData: roadData ? commutePick(roadData, roads.currentRoads) : undefined,
    roads,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IRoadsDispatchProps {
  return {
    onChangePopupRoadDistance: value => dispatch(changePopupRoadDistance(value)),
    onChangeRoadDistance: value => dispatch(changeRoadDistance(value)),
    onChangeSubroads: (ids, checked) => dispatch(changeSubroads(ids, checked)),
  };
}

export const RoadsContainer = connect<IRoadsProps, IRoadsDispatchProps>(mapStateToProps, mapDispatchToProps)(Roads);
